/** Management preview selector for the four login prototypes. Reachable at
 *  /login/preview only. Not linked from any production surface. */
import { useState } from "react";
import { Link } from "react-router-dom";
import OptionA from "./OptionA";
import OptionB from "./OptionB";
import OptionC from "./OptionC";
import OptionD from "./OptionD";
import OptionE from "./OptionE";
import OptionF from "./OptionF";
import OptionG from "./OptionG";

const OPTIONS = [
  { id: "E", label: "Living Lifecycle",    sub: "Wow · morphing lifecycle word + rail",     Comp: OptionE },
  { id: "F", label: "ONE Pulse",           sub: "Wow · vertical pulse + operating signals", Comp: OptionF },
  { id: "G", label: "Executive Questions", sub: "Wow · board-room rotating typography",     Comp: OptionG },
  { id: "A", label: "Executive Minimal",   sub: "Private banking · Apple-level restraint",  Comp: OptionA },
  { id: "B", label: "Corporate Split",     sub: "60/40 warm white + deep navy",             Comp: OptionB },
  { id: "C", label: "Lifecycle Signature", sub: "Typography-led · centred",                 Comp: OptionC },
  { id: "D", label: "Customer Workspace",  sub: "Tenant-owned feel · ONE in footer",        Comp: OptionD },
];

export default function LoginPreview() {
  const [active, setActive] = useState("E");
  const Current = (OPTIONS.find((o) => o.id === active) || OPTIONS[0]).Comp;

  return (
    <div className="min-h-screen bg-[color:var(--st-bg)]" data-testid="login-preview">
      {/* Selector — visible only on this route */}
      <div className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-[color:var(--st-border)]">
        <div className="max-w-6xl mx-auto flex items-center gap-3 h-12 px-4 overflow-x-auto">
          <div className="text-[10px] uppercase tracking-[0.18em] text-[color:var(--st-text-muted)] shrink-0 mr-2">
            Prototype preview
          </div>
          <nav className="flex items-center gap-1">
            {OPTIONS.map((o) => (
              <button key={o.id}
                onClick={() => setActive(o.id)}
                data-testid={`preview-tab-${o.id}`}
                className={
                  "h-8 px-3 rounded-md text-[12px] font-medium transition-colors whitespace-nowrap " +
                  (active === o.id
                    ? "bg-[color:var(--st-text)] text-white"
                    : "text-[color:var(--st-text-muted)] hover:bg-[color:var(--st-surface-alt)]")
                }>
                Option {o.id} · {o.label}
              </button>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden md:inline text-[11px] text-[color:var(--st-text-subtle)]">
              {(OPTIONS.find((o) => o.id === active) || OPTIONS[0]).sub}
            </span>
            <Link to="/login" className="text-[11px] uppercase tracking-[0.14em] text-[color:var(--st-text-muted)] hover:text-[color:var(--st-text)]">
              Production login →
            </Link>
          </div>
        </div>
      </div>

      <div className="min-h-[calc(100vh-48px)]">
        <Current />
      </div>
    </div>
  );
}
